import camelize from 'camelize';
import toSnakeCase from 'to-snake-case';
import queryString from 'query-string';

require('regenerator-runtime/runtime');

const setAccessToken = ({ headers }) => {
  if (headers && headers.get) {
    ['access-token', 'client', 'uid'].forEach(header => {
      if (headers.get(header)) {
        window.localStorage.setItem(header, headers.get(header));
      }
    });
  }
};

export const manuallySetCredentials = ({ accessToken, client, uid }) => {
  window.localStorage.setItem('access-token', accessToken);
  window.localStorage.setItem('client', client);
  window.localStorage.setItem('uid', uid);
};

// After confirmation, we can read and set credentials from the query string
export const setCredentialsFromQueryString = () => {
  const q = queryString.parse(window.location.search);
  if (q.uid && q.client_id && q.token && !q.reset_password) {
    manuallySetCredentials({
      uid: q.uid,
      client: q.client_id,
      accessToken: q.token,
    });
  }
};

export const clearAccessTokens = () => {
  ['access-token', 'client', 'uid'].forEach(header => {
    window.localStorage.removeItem(header);
  });
};

const readCredentials = () => ({
  'access-token': window.localStorage.getItem('access-token'),
  client: window.localStorage.getItem('client'),
  uid: window.localStorage.getItem('uid'),
});

const setDefaultOptions = () => ({
  credentials: 'include',
  headers: {
    ...readCredentials(),
    'X-Requested-With': 'XMLHttpRequest',
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});

const handleResponse = async response => {
  setAccessToken(response);

  if (response.ok) {
    const json = await response.json();
    return camelize(json);
  }

  if (response.status === 401 || response.status === 422) {
    const json = await response.json();
    return camelize(json);
  }

  throw new Error(response.status);
};

export const get = async url => {
  const options = { ...setDefaultOptions(), method: 'GET' };
  const response = await fetch(url, options);
  const json = await handleResponse(response);
  return json;
};

export const post = async (url, body, method = 'POST') => {
  const options = {
    ...setDefaultOptions(),
    method,
    body: JSON.stringify(body),
  };

  const response = await fetch(url, options);
  const json = await handleResponse(response);
  return json;
};

export const postFormData = async (url, object, method = 'POST') => {
  const formData = new FormData();
  Object.keys(object).forEach(key => {
    if (Array.isArray(object[key])) {
      object[key].forEach(value => {
        formData.append(`${toSnakeCase(key)}[]`, value);
      });
    } else {
      formData.append(toSnakeCase(key), object[key]);
    }
  });

  const options = {
    credentials: 'include',
    headers: {
      ...readCredentials(),
      'X-Requested-With': 'XMLHttpRequest',
    },
    method,
    body: formData,
  };

  const response = await fetch(url, options);
  const json = await handleResponse(response);
  return json;
};



// WEBPACK FOOTER //
// ./src/api/shared.js